import {useEffect, useState} from "react";
import StorageUtil from "@/common/StorageUtil";
import {TEAM_NAME} from "@/common/Constant";

const Splash = () => {
    const [teamName] = useState(StorageUtil.getLocalStorage(TEAM_NAME))
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        // 등장 애니메이션 트리거
        setVisible(true)
    }, [])

    return (
        <div className="splash-screen">
            <div className={`splash-text ${visible ? 'show' : ''}`}>
                {teamName}
            </div>
        </div>
    )
}

export default Splash
